import appIcon from "../../images/app_icon.jpg"
import "../../styles/PlayerCardItem.css"
import { loan as getLoan } from "../../tools/StockTools";

function PlayerCardItem({ size, card }) {
    let mode = "increased";
    const { company, rightIssue, shareSuspend, currency, loan, debenture, value, active, originalValue, comment, playerName } = card;
    let specialCard = null;
    if (rightIssue) specialCard = "Rights Issue"
    else if (shareSuspend) specialCard = "Share Suspend"
    else if (loan) specialCard = "Loan"
    else if (debenture) specialCard = "Debenture"
    else if (currency) specialCard = "Currency"

    let text = "";

    if (company) {
        if ((originalValue || value) < 0) mode = "decreased";
        text = ((originalValue || value) > 0 ? "+" : "") + (originalValue || value);
        if (playerName) {
            text = text + " (" + playerName + ")"
        }
    } else if (debenture || rightIssue || shareSuspend || loan) {
        if (!active) mode = "decreased";
        text = active ? "active" : "inactive"
    } else {
        if (currency < 0) mode = "decreased";
        text = (currency > 0 ? "+" : "") + currency + "%"
    }
    return (
        <div style={{ margin: "14px" }} onClick={() => {
            if (loan && active) {
                getLoan().then(data => {
                    if (data.error) {
                        alert(data.error);
                    }
                }).catch(e => { 
                    console.log(e);
                });
            }
        }}>
            <div className={`player-cards-item-container-${size}`}>
                <img className={`player-cards-item-image-${size}`} src={company ? `${process.env.REACT_APP_SERVER_URL}/image/${company}.png` : appIcon} alt=""></img>
                <div className={`player-cards-item-price-details-mode-${mode}`}>
                    {<p className="player-cards-item-company">{company ? company.toUpperCase() : specialCard}</p>}
                    {<p style={{ marginTop: "-10px" }}>{text}</p>}
                    {comment && <p style={{ color: "black", fontSize: "0.8rem" }}>{comment}</p>}
                </div>
            </div>
        </div>
    )
}

export default PlayerCardItem;